import {useState, useEffect} from 'react';
import axios from 'axios';
import {Post, UseFetchPostResult, UseFetchPrePostResult} from "../types/api";


// Безопасное получение переменных окружения
export const getApiUrl = (): string => {
    if (process.env.REACT_APP_API_BASE) {
        return process.env.REACT_APP_API_BASE;
    }
    return '/api';
};

const useFetchPost = (postId: number): UseFetchPostResult => {
    const [post, setPost] = useState<Post | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                setLoading(true);
                const apiUrl = getApiUrl();
                const response = await axios.get<Post>(`${apiUrl}/post/${postId}`);

                if (response.status !== 200) {
                    // Вместо throw устанавливаем ошибку через setError
                    setError(`HTTP error! status: ${response.status}`);
                    return;
                }

                setPost(response.data);
                setError(null);
            } catch (err) {
                // Обрабатываем ошибку без повторного throw
                const errorMessage = axios.isAxiosError(err)
                    ? `Не удалось загрузить пост: ${err.message}`
                    : "Не удалось загрузить пост";
                setError(errorMessage);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [postId]);

    return {post, loading, error};
};

export const useFetchPrePost = (): UseFetchPrePostResult => {
    const [posts, setPosts] = useState<Post[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = getApiUrl();
                const response = await axios.get<Post[]>(`${apiUrl}/post/`);
                console.log(response.data)
                if (response.status !== 200) {
                    // Вместо throw устанавливаем ошибку через setError
                    setError(`HTTP error! status: ${response.status}`);
                    return;
                }

                setPosts(response.data);
                setError(null);
            } catch (err) {
                // Обрабатываем ошибку без повторного throw
                if (axios.isAxiosError(err) && err.response?.status === 404) {
                    setError("Пост не найден");
                } else {
                    const errorMessage = err instanceof Error ? err.message : "Неизвестная ошибка";
                    setError(errorMessage);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return {posts, loading, error};
};

export default useFetchPost;